import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import type { Utente } from '@/types';

interface AuthState {
  utente: Utente | null;
  accessToken: string | null;
  refreshToken: string | null;
  setAuth: (utente: Utente, accessToken: string, refreshToken: string) => void;
  patchUtente: (patch: Partial<Utente>) => void;
  clearAuth: () => void;
}

export const useAuthStore = create<AuthState>()(
  persist(
    (set) => ({
      utente: null,
      accessToken: null,
      refreshToken: null,

      setAuth: (utente, accessToken, refreshToken) => {
        if (typeof window !== 'undefined') {
          localStorage.setItem('accessToken', accessToken);
          localStorage.setItem('refreshToken', refreshToken);
        }
        set({ utente, accessToken, refreshToken });
      },

      patchUtente: (patch) =>
        set((state) => ({ utente: state.utente ? { ...state.utente, ...patch } : null })),

      clearAuth: () => {
        if (typeof window !== 'undefined') {
          localStorage.removeItem('accessToken');
          localStorage.removeItem('refreshToken');
        }
        set({ utente: null, accessToken: null, refreshToken: null });
      },
    }),
    {
      name: 'finbroker-auth',
      partialize: (state) => ({ utente: state.utente }),
    }
  )
);
